// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"586abec6","117":"728dbb29","165":"8d0a2129","234":"1b621fed","237":"5ea18419","319":"5c79ba0a","453":"7ef8420d","624":"9af0f5dc"}[chunkId] + ".chunk.js";
};